export const deviceTypeNative = () => {
	const agent = navigator.userAgent.toLowerCase();
	if (agent.indexOf('android') !== -1 && window.masterpick && window.masterpick.nativeGetDeviceType) {
		window.masterpick.nativeGetDeviceType();
	} else if (
		(agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) &&
		window.webkit &&
		window.webkit.messageHandlers &&
		window.webkit.messageHandlers.nativeGetDeviceType
	) {
		window.webkit?.messageHandlers.nativeGetDeviceType.postMessage('');
	}
};

export const moveToLink = (url: string, type?: string) => {
	const agent = navigator.userAgent.toLowerCase();
	if (agent.indexOf('android') !== -1) {
		window.location.href = url;
		return;
	} else if (agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) {
		window.location.href = url;
		return;
	} else {
		window.open(url, type);
		return;
	}
};
